export default function initToggleBadges() {
  const $badgeReadMoreButton = $('[show-extra-badges]');
  if ($badgeReadMoreButton.length > 0) {
    const $badgeReadMoreContainer = $('[extra-badges-container]');
    const readLessTranslation = $badgeReadMoreButton.attr('read-less-text');
    const readMoreTranslation = $badgeReadMoreButton.attr('read-more-text');
    const $lastImage = $('[mobile-badges-container]').find('img').last();

    $badgeReadMoreButton.on('click', (e) => {
      if ($badgeReadMoreContainer.hasClass('d-none')) {
        $badgeReadMoreContainer.removeClass('d-none');
        $badgeReadMoreButton[0].innerText = readLessTranslation;
      } else {
        $badgeReadMoreContainer.addClass('d-none');
        $badgeReadMoreButton[0].innerText = readMoreTranslation;
        $lastImage[0].scrollIntoView();
      }
    });
  }
}
